import { createAction, props } from '@ngrx/store';
import { ZoneEntry } from 'app/core/zone-search/municipality-zone.model';
import { Popup } from 'app/shared/ll/components/popup.component';
import { Bounds } from 'app/shared/ll/models/bounds';
import { Position } from 'app/shared/ll/models/geometry';
import { ViewRequest } from 'app/shared/ll/models/map';
import { MunicipalLandUsePlanEntry } from '../land-use-plan-search/land-use-plan.model';
import { Measure } from './measure.model';
import { LocateRequest } from './search-bar/autocomplete.model';


export const changeBaseMap = createAction('[Map] Change base map', props<{ baseMap: string }>());

export const setView = createAction('[Map] Set view', props<ViewRequest>());

export const boundsChange = createAction('[Map] Bounds change', props<{ bounds: Bounds }>());

export const showBubble = createAction('[Map] Show bubble', props<{ bubble: Popup }>());

export const hideBubble = createAction('[Map] Hide bubble');

export const addZonePolygon = createAction('[Map] Add zone polygon', props<{ zone: ZoneEntry }>());

export const removeZonePolygon = createAction('[Map] Remove zone polygon', props<{ index: number }>());

export const addLandUsePlanPolygon = createAction('[Map] Add land use polygon', props<{ landUsePlan: MunicipalLandUsePlanEntry }>());

export const removeLandUsePlanPolygon = createAction('[Map] Remove land use polygon', props<{ index: number }>());

export const addMeasureAndStopDrawing = createAction('[Map] Add measure', props<{ measure: Measure }>());

export const clearMeasures = createAction('[Map] Clear measures');

export const locate = createAction('[Map] Locate on map', props<LocateRequest>());

export const centerToProperty = createAction('[Map] Center to property', props<{ location: Position; offset?: Position }>());

export const centerToBounds = createAction('[Map] Center to bounds', props<{ bounds: Position[] }>());

export const showMovingMarker = createAction('[Map] Show moving marker', props<{ location: Position }>());
